<section class="faq-page">
  <div class="faq-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>Frequently Asked Questions</h1>
      <p>Quick answers to common questions about YoGamez Hub services and account usage.</p>
    </div>
  </div>

  <div class="faq-content">
    <article class="faq-card">
      <h2>FAQs</h2>
      <p class="faq-intro">
        Browse common questions and answers below.
      </p>

      <p class="faq-state" *ngIf="isLoading">Loading FAQs...</p>
      <p class="faq-state error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</p>
      <p class="faq-state" *ngIf="!isLoading && !errorMessage && faqs.length === 0">{{ emptyMessage }}</p>

      <div class="faq-list" *ngIf="!isLoading && !errorMessage && faqs.length > 0">
        <details class="faq-item" *ngFor="let faq of faqs; let i = index" [attr.open]="i === 0 ? true : null">
          <summary>{{ faq.question }}</summary>
          <p>{{ faq.answer }}</p>
        </details>
      </div>
    </article>
  </div>
</section>
